<template>
  <section class="section with-min-height">
    <div class="container is-fullwidth has-text-centered">
      <p>Please wait while we retrieve your quote&hellip;</p>
    </div>
  </section>
</template>

<script>
import { mapActions, mapMutations } from 'vuex';

export default {
  name: 'Connect',
  props: {
    token: {
      type: String,
      default: null
    }
  },
  beforeMount() {
    this.retrieveQuote();
  },
  methods: {
    ...mapActions(['fetchPrefillQuote']),
    ...mapMutations(['toggleLoader']),
    retrieveQuote() {
      if (!this.token) {
        this.$router.replace('/receive-a-quote');
        return;
      }
      this.toggleLoader({
        loaderText: 'Please wait while we retrieve your information.'
      });
      this.fetchPrefillQuote(this.token)
        .then(() => {
          this.toggleLoader();
          this.$router.replace('/receive-a-quote');
        })
        .catch(() => {
          this.toggleLoader();
          this.$router.replace('/receive-a-quote');
          this.$snackbar.open({
            type: 'is-danger',
            message: `We were unable to retrieve your quote. Please complete the form below to receive a new quote.`,
            position: 'is-bottom'
          });
        });
    }
  }
};
</script>

<style scoped></style>
